import Head from 'expo-router/head';

import { OrderScreen } from '@fhs/cart';

export default function OrderPage() {
  return (
    <>
      <Head>
        <title>Order - Firehouse Subs</title>
      </Head>
      <OrderScreen />
    </>
  );
}
